import { useQuery } from "@apollo/client"
import { IS_FEATURE_AVAILABLE } from "data/layoutcreator/queries/featureFlags"

export const useFeatureFlag = (key: string) => {
  const { data } = useQuery(IS_FEATURE_AVAILABLE, {
    variables: {
      key,
    },
  })

  return data?.isFeatureAvailable
}
